export class BackendError extends Error {
  status_code: string | number | null;
  message: string;
  message_translation_key?: string;
  constructor(
    _status_code: string | number | null,
    _message: string,
    _message_translation_key?: string,
  ) {
    super(_message);
    this.name = 'BackendError';
    this.status_code = _status_code;
    this.message = _message;
    this.message_translation_key = _message_translation_key;
  }
}

export const isBackendError = (error: unknown): error is BackendError => {
  if (typeof error !== 'object' || error === null) return false;

  const { status_code, message } = error as {
    status_code?: unknown;
    message?: unknown;
  };
  const hasValidStatusCode =
    typeof status_code === 'string' ||
    (typeof status_code === 'number' && !Number.isNaN(status_code));

  return hasValidStatusCode && typeof message === 'string';
};
